import React, { useContext, useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"

import { isAuth, signout } from "../helpers/auth"
import SessionContext from "../helpers/SessionContext"

const UserMenu = () => {
  const { setSession } = useContext(SessionContext)
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const dropdownRef = useRef(null)

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className="relative ml-4" ref={dropdownRef}>
      <button
        className="flex items-center text-white hover:text-gray-300 font-medium focus:outline-none"
        onClick={toggleDropdown}
      >
        User
        <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
          <path
            clipRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.061l-4.24 4.25a.75.75 0 01-1.06 0l-4.25-4.25a.75.75 0 01.02-1.06z"
            fillRule="evenodd"
          />
        </svg>
      </button>

      {dropdownOpen && (
        <div className="absolute right-0 mt-2 w-44 bg-white text-black rounded-md shadow z-[50] border border-gray-200">
          {isAuth()?.role === "admin" && (
            <a
              className="block w-full px-6 py-2 text-[0.95rem] font-normal text-[#212529] text-left whitespace-nowrap bg-transparent hover:bg-gray-100"
              href="/admin"
            >
              Admin Config
            </a>
          )}
          <a
            className="block w-full px-6 py-2 text-[0.95rem] font-normal text-[#212529] text-left whitespace-nowrap bg-transparent hover:bg-gray-100"
            href="/settings"
          >
            Settings
          </a>
          <hr className="my-1 border-gray-200" />
          <button
            className="block w-full px-6 py-2 text-[0.95rem] font-normal text-[#212529] text-left whitespace-nowrap bg-transparent hover:bg-gray-100"
            onClick={() => {
              signout(() => {
                toast.error("Logout Successfully")
                setSession(false)
              })
            }}
          >
            Log Out
          </button>
        </div>
      )}
    </div>
  )
}

export default UserMenu
